import request from '#/utils/request';
import { hydrateJsonBlobError } from '#/utils/blobResponseError';

function parseFilenameFromContentDisposition(header) {
  if (!header || typeof header !== 'string') {
    return null;
  }

  const utf8Match = /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ''));
    } catch {
      return utf8Match[1].trim().replace(/^"|"$/g, '');
    }
  }

  const plainMatch = /filename="?([^";]+)"?/i.exec(header);
  return plainMatch?.[1]?.trim() || null;
}

/**
 * FMS 列印：POST 產生 PDF 並寫列印紀錄；成功為 `application/pdf` binary（非 JSON envelope）。
 * 列印者由後端從 Bearer token 取得，契約明訂不接受 `X-User-Id`，故不經 `withFmsActor`。
 * @see backend-docs docs/api/fms/print-routes.md
 *
 * @returns {Promise<{ blob: Blob, filename: string }>}
 */
export async function postFmsPrintPdf(url, { params, fallbackFilename = 'print.pdf' } = {}) {
  try {
    const response = await request.post(
      url,
      null,
      { responseType: 'blob', params },
    );
    const disposition = response.headers?.['content-disposition']
      ?? response.headers?.['Content-Disposition'];
    return {
      blob: response.data,
      filename: parseFilenameFromContentDisposition(disposition) || fallbackFilename,
    };
  } catch (error) {
    await hydrateJsonBlobError(error);
    throw error;
  }
}
